import {Box, Divider, Typography} from '@mui/material';
import Dialog from 'components/Dialog';
import Panel from 'components/Panel';
import {AuthenticatorForm} from 'features/login/AuthenticatorForm';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {_mfaSetupResp} from 'types/diplomat/authentication/MfaSetupResponse';
import {useVerifyCode} from './redux/hooks/useVerifyCode';
import {useStyles} from './styles';

type Props = {
   onClose: (status?: boolean) => void;
};

export const AuthenticatorVerifyDialog = ({onClose}: Props) => {
   const {t} = useTranslation();
   const onSubmit = useVerifyCode(onClose);
   const classes = useStyles();

   return (
      <Dialog maxWidth="sm" header={t('Verify Authentication Code')}>
         <div className={classes.root}>
            {/* <Typography variant="h1">{}</Typography> */}
            <Typography variant="overline" gutterBottom>
               {t(
                  'Your account requires two-factor authentication to log in. Enter the code displayed in your Authenticator app to complete login.'
               )}
            </Typography>
            <Panel>
               <AuthenticatorForm onSubmit={onSubmit} onClose={onClose} allowBackupCodes />
            </Panel>
         </div>
      </Dialog>
   );
};
